import React from "react";
import { Button } from "antd";
import { Plus } from "lucide-react";
import { DataTable } from "../../components/DataTable";
import { ISubAdminPayload } from "../../../types/api/subAdmin";
import { getSubAdminColumns } from "./SubAdminColumns";

interface SubAdminPanelProps {
  list: ISubAdminPayload[];
  total: number;
  loading: boolean;
  isError: boolean;
  queryData: any;
  search: string;
  onSearchChange: (v: string) => void;
  onPageChange: (page: number, limit: number) => void;
  onAdd: () => void;
  onEdit: (record: ISubAdminPayload) => void;
  onToggleStatus: (record: ISubAdminPayload) => void;
}

export const SubAdminPanel: React.FC<SubAdminPanelProps> = ({
  list,
  total,
  loading,
  isError,
  queryData,
  search,
  onSearchChange,
  onPageChange,
  onAdd,
  onEdit,
  onToggleStatus,
}) => {
  const columns = getSubAdminColumns({ onEdit, onToggleStatus });

  return (
    <DataTable
      title={<h1 className="text-xl font-semibold text-slate-800">Admin Users</h1>}
      headerActions={
        <Button
          type="primary"
          size="small"
          icon={<Plus size={16} />}
          onClick={onAdd}
          className="!bg-primary flex items-center gap-2"
        >
          Add Admin User
        </Button>
      }
      dataSource={list}
      columns={columns}
      loading={loading}
      isError={isError}
      rowKey="_id"
      searchProps={{
        searchValue: search,
        onSearchChange,
        placeholder: "Search by name or email...",
      }}
      paginationProps={
        queryData
          ? {
              page: queryData.page ?? 1,
              limit: queryData.limit ?? 10,
              total,
              onChange: (page: number, pageSize: number) => onPageChange(page, pageSize),
            }
          : undefined
      }
    />
  );
};
